export default "__VITE_ASSET__BWxydK3W__"